import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import Live from "../page";

const routes: AppRouteType[] = [
  {
    path: slugs.live,
    component: Live,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
